const sanitizeString = (str) => {
    str = str.toLowerCase();
    str = str.replace(/[áàãâä]/gi, 'a');
    str = str.replace(/[éèêë]/gi, 'e');
    str = str.replace(/[íìîï]/gi, 'i');
    str = str.replace(/[óòõôö]/gi, 'o');
    str = str.replace(/[úùûü]/gi, 'u');
    str = str.replace(/[ç]/gi, 'c');
    str = str.replace(/[,(),;:|!"#$%&/=?~^><ªº-]/g, '_');
    str = str.replace(/[^a-z0-9]/gi, '_');
    str = str.replace(/_+/g, '_');
    return str;
}

const SanitizeUsername = (str) => {
    str = str.replace(/[áàãâä]/gi, 'a');
    str = str.replace(/[ÁÀÄÂÃ]/gi, 'A');
    str = str.replace(/[éèêë]/gi, 'e');
    str = str.replace(/[ÉÈÊË]/gi, 'E');
    str = str.replace(/[íìîï]/gi, 'i');
    str = str.replace(/[ÍÌÎÏ]/gi, 'I');
    str = str.replace(/[óòõôö]/gi, 'o');
    str = str.replace(/[ÓÒÕÔÖ]/gi, 'O');
    str = str.replace(/[úùûü]/gi, 'u');
    str = str.replace(/[ÚÙÛÜ]/gi, 'U');
    str = str.replace(/[ç]/gi, 'c');
    str = str.replace(/[Ç]/gi, 'C');
    str = str.replace(/[^a-z0-9A-Z_-]/gi, '');
    return str;
}

export {
    sanitizeString,
    SanitizeUsername
};